import get from 'lodash/get';

import { AppRootState } from '../../../../../store/models/app-state.model';
import {
  APPS_FEATURE,
  APPS_FILES,
} from '../../../../../store/utils/files-names';

export const getApkIdsSelector = (state: AppRootState): number[] =>
  get(state, `${APPS_FEATURE}.${APPS_FILES}`).apks;
